import {
  ExtranetPendingChangeRequestType,
  ExtranetPendingChangeStatus,
  ListExtranetPendingChangesParams,
} from '~/services/ExtranetService';

import { DEFAULT_FILTERS, HISTORY_TAB, HOMES_VILLAS_PENDING_TAB, PAGE_SIZE, PENDING_TAB } from './constants';
import type { Filters } from './types';

export function getQueryParam(query: URLSearchParams, ...names: Array<string>) {
  for (const name of names) {
    const value = query.get(name);
    if (value) {
      return value;
    }
  }
  return '';
}

export function getTabFromQuery(tab: string) {
  if (tab === 'homes-villas-pending') {
    return HOMES_VILLAS_PENDING_TAB;
  }
  return tab === 'history' ? HISTORY_TAB : PENDING_TAB;
}

export function getTabQueryValue(activeTab: number) {
  if (activeTab === HOMES_VILLAS_PENDING_TAB) {
    return 'homes-villas-pending';
  }
  return activeTab === HISTORY_TAB ? 'history' : 'pending';
}

export function getDefaultStatusForTab(activeTab: number) {
  return activeTab === HISTORY_TAB ? '' : 'pending';
}

export function getDefaultPropertyCategoryForTab(activeTab: number) {
  return activeTab === HOMES_VILLAS_PENDING_TAB ? 'Homes & Villas' : '';
}

export function buildFilterSearch(filters: Filters, activeTab: number, changeId?: string) {
  const params = new URLSearchParams({ tab: getTabQueryValue(activeTab) });
  if (filters.vendor_id) {
    params.set('vendor_id', filters.vendor_id);
  }
  if (filters.property_id) {
    params.set('property_id', filters.property_id);
  }
  if (activeTab === HISTORY_TAB && filters.request_type) {
    params.set('request_type', filters.request_type);
  }
  if (activeTab === HISTORY_TAB && filters.status) {
    params.set('status', filters.status);
  }
  if (changeId) {
    params.set('changeId', changeId);
  }
  return `?${params.toString()}`;
}

export function getTabFromChangeStatus(status: ExtranetPendingChangeStatus) {
  return status === 'pending' ? PENDING_TAB : HISTORY_TAB;
}

export function getFiltersFromQuery(query: URLSearchParams, activeTab: number): Filters {
  return {
    ...DEFAULT_FILTERS,
    status: activeTab === HISTORY_TAB ? getQueryParam(query, 'status') : getDefaultStatusForTab(activeTab),
    vendor_id: getQueryParam(query, 'vendor_id', 'vendorId'),
    property_id: getQueryParam(query, 'property_id', 'propertyId'),
    request_type: activeTab === HISTORY_TAB ? getQueryParam(query, 'request_type', 'requestType') : '',
    property_category: getDefaultPropertyCategoryForTab(activeTab),
  };
}

export function buildListParams(
  filters: Filters,
  page: number,
  statusOverride?: string,
): ListExtranetPendingChangesParams {
  const params: ListExtranetPendingChangesParams = { limit: PAGE_SIZE, page };
  const status = statusOverride ?? filters.status;
  if (status) {
    params.status = status;
  }
  if (filters.vendor_id) {
    params.vendor_id = filters.vendor_id;
  }
  if (filters.request_type) {
    params.request_type = filters.request_type as ExtranetPendingChangeRequestType;
  }
  if (filters.property_id) {
    params.property_id = filters.property_id;
  }
  if (filters.property_category) {
    params.propertyCategory = filters.property_category;
  }
  return params;
}
